import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router'
import { useFetchAuthorisation, authorisationConverter, useFetchUserData } from '../../utils/AppFunctions'
import config from '../../app-config'
import 'react-toastify/dist/ReactToastify.css';
import AdminLayout from '../../layouts/AdminLayout'
import { MdAdd, MdMusicNote, MdPersonAdd } from 'react-icons/md';
import { tidy_date, tidy_date_raw } from '../../utils/helper';
import DataTable from '../../components/ui/DataTable';

export default function MinistryPage() {
  const navigate = useNavigate()
  const { isAuthorised, userRole } = useFetchAuthorisation("user")
  let user_data = useFetchUserData()

  const [ministryData, setMinistryData] = useState([])
  const [loading, setLoading] = useState(true)
  const [query, setQuery] = useState("")

  useEffect(() => {
    fetchMinistry()
  }, [])

  const fetchMinistry = async () => {
    setLoading(true)
    let endpoint = config.endpoint + "/ministry/"
    let response = await fetch(endpoint, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
    })
    let data = await response.json()
    if (data.status === 200) {
      setMinistryData(data.data)
    }
    setLoading(false)
  }


  const table_columns = [
    {
      header: "Name",
      accessor: "name"
    },
    {
      header: "Tagline",
      accessor: "tagline"
    },
  ]

  return (
    <AdminLayout
      navSelected={"Ministry"}
      toolbar={
        <>
          <h1 className='text-lg font-semibold text-gray-900'>Ministries</h1>
          <button
            className="inline-flex items-center px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium rounded-lg shadow-sm transition-colors duration-200 gap-2"
            onClick={() => {
              navigate("/admin/ministry/details?ministry_id=new")
            }}
          >
            <MdAdd size={16} />
            New Ministry
          </button>
        </>
      }
    >
      {/* Search */}
      {/* <div className="column items-center justify-between w-100 mb-40">
        <input
          type="text"
          placeholder="Search..."
          className='text-input w-100'
          value={query}
          onChange={(e) => {
            setQuery(e.target.value)
          }}
        />
       
      </div> */}

      {loading ? (
        <div className="flex-row items-center flex justifyCenter w-100">
          <h1>Loading...</h1>
        </div>
      ) : (
        <div className="w-100">
          {/* {ministryData.map((ministry, index) => {
            if (!JSON.stringify(ministry)?.toLowerCase().includes(query.toLowerCase())) return null

            return (
              <div
                key={index}
                className="flex-row items-center flex justify-between w-100 card mt-10"
              >
                <div className="">
                  <h3>{ministry.name}</h3>
                  <h3 className='card-subtitle gray'>{ministry?.tagline}</h3>
                </div>
                <button
                  className="button"
                  onClick={() => {
                    navigate("/admin/ministry/details?ministry_id=" + ministry.id)
                  }}
                >
                  View
                </button>
              </div>
            )
          })} */}
          <DataTable
            columns={table_columns}
            data={ministryData}
            enableActions
            actions={(row) => {
              return (
                <div className="flex gap-2">
                  <button className="hover:underline" onClick={() => navigate(`/admin/ministry/details?ministry_id=${row.id}`)}>
                    Edit
                  </button>
                </div>
              )
            }}
          />
        </div>
      )}
    </AdminLayout>
  )
}
